import { useGetAssignedJobs } from '@/api'
import { DesktopJobsDashboard } from '@/components/Domains/Jobs'
import { Page } from '@eigtech/ui-shared-dave'
import { createFileRoute } from '@tanstack/react-router'
import { HomepageToolbar } from '..'

export const Route = createFileRoute('/_auth/jobs/')({
  component: JobsDashboard,
})

function JobsDashboard() {
  const { isPending } = useGetAssignedJobs()

  return (
    <Page
      aboveHeader={<HomepageToolbar />}
      heading="Your Assigned Jobs"
      isFullWidth
      isPending={isPending}
    >
      <DesktopJobsDashboard />
    </Page>
  )
}
